'use client';

const MenuVariant = ({ blok }) => {
  // const { desktop } = useBreakpoints();
  // blok.menu_component_data.forEach((item) => {
  //   const tempArr: CMSOuterMenuDataItemBlockType[] = [];
  //   item.blocks.forEach((block) => {
  //     if (!isOutdated(block.published_at, block.ended_at)) {
  //       tempArr.push(block);
  //     }
  //     item.blocks = tempArr;
  //   });
  // });

  // if (!desktop) {
  //   return <MobileMenu blok={blok} />;
  // }

  // return <DesktopMenu blok={blok} />;
  return '';
};

export { MenuVariant };
